import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import {
    Toolbar,
} from '@mui/x-data-grid-pro'
import SkyBaseClearSortingButton
    from './SkyBaseClearSortingButton'
import SkyBaseColumnMenu from './SkyBaseColumnMenu'
import {
    SkyBaseDataGridToolbarProps,
} from './SkyBaseDataGridToolbar.types'
import QuickFilterToolbarItem
    from './QuickFilterToolbarItem'
import SkyBaseFilterButton
    from './SkyBaseFilterButton'
import SkyBaseExportToolbarMenu from './ExportToolbarMenu'
import useStyles
    from './SkyBaseDataGridToolbar.styles'

export default function SkyBaseDataGridToolbar({
    classNames,
    clearSortButton: ClearSortButton = SkyBaseClearSortingButton,
    columnMenu: ColumnMenu = SkyBaseColumnMenu,
    exportToolbarMenu: ExportToolbarMenu = SkyBaseExportToolbarMenu,
    filterButton: FilterButton = SkyBaseFilterButton,
    quickFilterToolbar: QuickFilter = QuickFilterToolbarItem,
    showColumnMenu = true,
    showClearSort = true,
    showExportToolbarMenu = false,
    showFilterButton = true,
    showQuickFilter = false,
    title,
    toolbarControls = [],
}: Readonly<SkyBaseDataGridToolbarProps>) {
    const {
        classes, cx,
    } = useStyles()

    return (
        <Toolbar
            data-testid="custom-toolbar"
            className={cx(classes.toolbar, classNames?.toolbar)}
        >
            {title ? (
                <Typography
                    className={classes.title}
                    variant="h2"
                >
                    {title}
                </Typography>
            ) : null}
            <div className={classes.toolbarControlEls}>
                {showQuickFilter ? (
                    <>
                        <QuickFilter />
                        <Divider
                            orientation="vertical"
                            flexItem
                            variant="middle"
                            sx={{
                                mx: 1,
                                height: '20px',
                            }}
                        />
                    </>
                ) : null}
                <div className={classes.toolbarControlEls}>
                    {toolbarControls?.map((control, index) => {
                        return (
                            <div
                                className={classes.toolbarControlEl}
                                // eslint-disable-next-line react/no-array-index-key
                                key={`toolbar-control-${index}`}
                            >
                                {control}
                            </div>
                        )
                    })}
                </div>
                {showExportToolbarMenu ? <ExportToolbarMenu /> : null}
                {showFilterButton ? <FilterButton /> : null}
                {showClearSort ? <ClearSortButton /> : null}
                {showColumnMenu ? <ColumnMenu /> : null}
            </div>
        </Toolbar>
    )
}
